<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    export let fill: string = $theme.colors.white;
</script>

<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.4587 9.99996C18.4587 14.6023 14.7277 18.3333 10.1253 18.3333C5.52295 18.3333 1.79199 14.6023 1.79199 9.99996C1.79199 5.39759 5.52295 1.66663 10.1253 1.66663C14.7277 1.66663 18.4587 5.39759 18.4587 9.99996ZM7.60002 7.47467C7.84409 7.23059 8.23982 7.23059 8.4839 7.47467L10.1253 9.11607L11.7667 7.47468C12.0108 7.23061 12.4065 7.23061 12.6506 7.47468C12.8946 7.71876 12.8946 8.11449 12.6506 8.35857L11.0092 9.99995L12.6505 11.6413C12.8946 11.8854 12.8946 12.2811 12.6505 12.5252C12.4065 12.7693 12.0107 12.7693 11.7667 12.5252L10.1253 10.8838L8.48392 12.5252C8.23984 12.7693 7.84411 12.7693 7.60003 12.5252C7.35596 12.2811 7.35596 11.8854 7.60003 11.6413L9.24142 9.99995L7.60002 8.35855C7.35594 8.11447 7.35594 7.71875 7.60002 7.47467Z"
        {fill}
    />
</svg>
